// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"da931e2c","151":"29f248de","382":"656a3eac","453":"51a16142","659":"f8f893c9","681":"70180745","750":"671aa6b1","938":"2be4d29a"}[chunkId] + ".chunk.js";
};